export default __webpack_public_path__ + "static/media/damodar_bhandari.acd15a09.jpg";